import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { DESKTOP_WIDTH, HEADER_HEIGHT, MOBILE_WIDTH } from 'Styles/variables/sizes';

export const NavStyled = styled.nav`
  max-width: ${pxToRem(320)};
  background-color: ${({ theme: { colors } }) => colors.white};
  max-height: 88vh;
  overflow-y: auto;
  scrollbar-gutter: stable;
  flex: 1;
  position: sticky;
  top: 0;
  align-self: flex-start;
  transition: transform 0.3s ease-in-out 0s;
  h5 {
    padding: 0 ${pxToRem(24)};
    margin: ${pxToRem(24)} 0;
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    position: fixed;
    width: 100%;
    max-width: ${pxToRem(360)};
    top: ${HEADER_HEIGHT};
    bottom: 0px;
    right: 0;
    left: 0px;
    transform: translateX(-100%);
    z-index: 3;
    padding: ${pxToRem(20)};
    border-right: 1px solid ${({ theme: { colors } }) => colors.grey_1};
    &.is-open {
      display: block;
      transform: translateX(0px);
    }
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    max-height: 100%;
    overflow: auto;
    max-width: 100%;
    border: none;
  }
`;

export const SubLinksContent = styled.ul`
  > li {
    border-top: 1px solid ${({ theme: { colors } }) => colors.grey_1};
  }
  > li:last-child {
    border-bottom: 1px solid ${({ theme: { colors } }) => colors.grey_1};
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    height: ${pxToRem(500)};
    overflow: auto;
  }
`;
